export default {
  apiPath: '',
  enableDevMode: false,
};
